import { CCol, CContainer, CRow } from "@coreui/react";
import React from "react";
import { Link } from "react-router-dom";

export default function Banner({ banner, subtext, text }) {
  return (
    <>
      <div
        className="banner-bg-wrapper"
        style={{ backgroundImage: `url(${banner})` }}
      >
        <div className="banner-content-wrapper">
          <CContainer>
            <CRow>
              <CCol lg={12}>
                <div className="banner-content-placeholder">
                  <div className="banner-content mt-lg-4 mt-0">
                    <label>{subtext}</label>
                    <h3>{text}</h3>
                  </div>
                  <div className="go-home-wrapper">
                    <Link to={"/"}>go to Home</Link>
                  </div>
                </div>
              </CCol>
            </CRow>
          </CContainer>
        </div>
      </div>
    </>
  );
}
